export default __webpack_public_path__ + "static/media/temp-results-img-2.7ea2f39f.jpg";